import { cloneDeep, get } from 'lodash';
import calcShortcutInterval from '@utils/calcShortcutInterval';
import { DASHBOARD_TYPE } from '@utils/constants';

export default function scrollingWindowFromTo(obj) {
  const res = { ...obj };
  if (get(obj, 'config.interval.shortcut') && get(obj, 'config.interval.scrollingWindow')) {
    const [from, to] = calcShortcutInterval(obj.config.interval.shortcut);
    res.config.interval.from = from.format();
    res.config.interval.to = to.format();
  }
  if (get(obj, 'base.interval.shortcut') && get(obj, 'base.interval.scrollingWindow')) {
    const [from, to] = calcShortcutInterval(obj.base.interval.shortcut);
    res.base.interval.from = from.format();
    res.base.interval.to = to.format();
  }
  return res;
}

export function scrollingWindowByStore(store) {
  // eslint-disable-next-line prefer-const, object-curly-newline
  let { from, to } = store.interval;
  const { shortcut, scrollingWindow } = store.interval;
  if (shortcut.toLowerCase() !== 'custom' && scrollingWindow) {
    const [f, t] = calcShortcutInterval(shortcut);
    from = f.format();
    to = t.format();
  }
  if (typeof from === 'object') { from = from.format(); }
  if (typeof to === 'object') { to = to.format(); }
  return {
    shortcut,
    from,
    to,
    scrollingWindow,
  };
}

export function setFromToByScrollingMark(input) {
  let obj = input;
  if (typeof input === 'string') {
    obj = JSON.parse(input);
  }
  // tabsData
  if (obj && obj.tabsData) {
    const h = obj.tabsData;
    Object.keys(h).forEach((e) => {
      const el = h[e];
      if (el.config && el.config.interval && el.config.interval.scrollingWindow) {
        const { interval } = el.config;
        const [from, to] = calcShortcutInterval(interval.shortcut);
        if (from == null || to == null) { return; }
        interval.from = from.format();
        interval.to = to.format();
      }
    });
  }
  // dashboards
  if (obj && obj.dashboards) {
    const h = obj.dashboards;
    Object.keys(h).forEach((e) => {
      const d = h[e];
      if (get(d, 'dashboard.base.interval.scrollingWindow', false)) {
        const { interval } = d.dashboard.base;
        const [from, to] = calcShortcutInterval(interval.shortcut);
        if (from == null || to == null) { return; }
        interval.from = from.format();
        interval.to = to.format();
      }
    });
  }
}

export function cloneWithoutFromTo(obj) {
  const clone = cloneDeep(obj);
  if (clone && clone.interval && clone.interval.scrollingWindow) {
    delete clone.interval.from;
    delete clone.interval.to;
  }
  return clone;
}

export function cloneWithoutSelectedMetrics(obj, type) {
  if (type !== DASHBOARD_TYPE.ERROR_DIAGNOSTICS) { return obj; }
  const clone = cloneDeep(obj);
  if (clone && clone.viewerSessionsTable && clone.viewerSessionsTable.selectedMetrics) {
    delete clone.viewerSessionsTable.selectedMetrics;
  }
  return clone;
}
